export default function StatusBadge({ status, type = "invoice" }) {
  const colors = {
    invoice: {
      available:     "bg-green-100 text-green-800",
      pending:       "bg-yellow-100 text-yellow-800",
      "not available": "bg-red-100 text-red-800",
      downloaded:    "bg-blue-100 text-blue-800",
      requested:     "bg-purple-100 text-purple-800",
    },
    email: {
      delivered: "bg-green-100 text-green-800",
      clicked:   "bg-blue-100 text-blue-800",
      bounced:   "bg-red-100 text-red-800",
      dropped:   "bg-gray-100 text-gray-800",
    },
    request: {
      open:               "bg-yellow-100 text-yellow-800",
      "in progress":      "bg-blue-100 text-blue-800",
      "pending client":   "bg-orange-100 text-orange-800",
      "pending approval": "bg-orange-100 text-orange-800",
      resolved:           "bg-green-100 text-green-800",
      closed:             "bg-gray-100 text-gray-800",
    },
  };
  const map = colors[type] || colors.invoice;
  const color = map[status?.toLowerCase()] || "bg-gray-100 text-gray-800";
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${color}`}>
      {status}
    </span>
  );
}
